export const ChatAnalysisLogEvent = {
  CHAT_ANALYSIS_CREATE_VIEWED: {
    amp: 'Chat Analysis Create - Viewed',
    ga: 'chat_analysis_create_viewed',
  }, // [채팅 분석 생성] 화면 진입
  CHAT_ANALYSIS_CREATE_TYPE_CLICKED: {
    amp: 'Chat Analysis Create - Type Clicked',
    ga: 'chat_analysis_create_type_clicked',
  }, // [채팅 분석 생성] 타입 상단 버튼 클릭
  CHAT_ANALYSIS_CREATE_FILE_SELECTED: {
    amp: 'Chat Analysis Create - File Selected',
    ga: 'chat_analysis_create_file_selected',
  }, // [채팅 분석 생성] 파일 선택
  CHAT_ANALYSIS_CREATE_ANALYZE_BUTTON_CLICKED: {
    amp: 'Chat Analysis Create - Analyze Button Clicked',
    ga: 'chat_analysis_create_analyze_button_clicked',
  }, // [채팅 분석 생성] 분석하기 클릭
  CHAT_ANALYSIS_CREATE_TUTORIAL_BUTTON_CLICKED: {
    amp: 'Chat Analysis Create - Tutorial Button Clicked',
    ga: 'chat_analysis_create_tutorial_button_clicked',
  }, // [채팅 분석 생성] 방법 확인하기 클릭
  CHAT_ANALYSIS_CREATE_SHARE_CLICKED: {
    amp: 'Chat Analysis Create - Share Clicked',
    ga: 'chat_analysis_create_share_clicked',
  }, // [채팅 분석 생성] 공유하기 클릭
  CHAT_ANALYSIS_LOADING_VIEWED: {
    amp: 'Chat Analysis Loading - Viewed',
    ga: 'chat_analysis_loading_viewed',
  }, // [그룹 채팅 분석 로딩] 화면 진입
  CHAT_ANALYSIS_SELF_SELECT_VIEWED: {
    amp: 'Chat Analysis Self Select - Viewed',
    ga: 'chat_analysis_self_select_viewed',
  }, // [그룹 채팅 분석 본인 선택] 화면 진입
  CHAT_ANALYSIS_SELF_SELECT_NAME_SELECTED: {
    amp: 'Chat Analysis Self Select - Name Selected',
    ga: 'chat_analysis_self_select_name_selected',
  }, // [그룹 채팅 분석 본인 선택] 이름 클릭
  CHAT_ANALYSIS_SELF_SELECT_SUBMIT: {
    amp: 'Chat Analysis Self Select - Submit',
    ga: 'chat_analysis_self_select_submit',
  }, // [그룹 채팅 분석 본인 선택] 선택 완료
  CHAT_ANALYSIS_RESULT_NOT_FOUND_CLICKED: {
    amp: 'Chat Analysis Result - Not Found Clicked',
    ga: 'chat_analysis_result_not_found_clicked',
  }, // [그룹 채팅 분석 본인 선택] 찾을 수 없음 클릭
  CHAT_ANALYSIS_RESULT_VIEWED: {
    amp: 'Chat Analysis Result - Viewed',
    ga: 'chat_analysis_result_viewed',
  }, // [그룹 채팅 분석 결과] 화면 진입
  CHAT_ANALYSIS_RESULT_EDIT_CLICKED: {
    amp: 'Chat Analysis Result - Edit Clicked',
    ga: 'chat_analysis_result_edit_clicked',
  }, // [그룹 채팅 분석 결과] 이름 수정 버튼 클릭
  CHAT_ANALYSIS_RESULT_SUMMARY_CLICKED: {
    amp: 'Chat Analysis Result - Summary Clicked',
    ga: 'chat_analysis_result_summary_clicked',
  }, // [그룹 채팅 분석 결과] 요약 클릭
  CHAT_ANALYSIS_RESULT_NAME_CLICKED: {
    amp: 'Chat Analysis Result - Name Clicked',
    ga: 'chat_analysis_result_name_clicked',
  }, // [그룹 채팅 분석 결과] 이름 클릭
  CHAT_ANALYSIS_RESULT_SHARE_CLICKED: {
    amp: 'Chat Analysis Result - Share Clicked',
    ga: 'chat_analysis_result_share_clicked',
  }, // [그룹 채팅 분석 결과] 공유하기 클릭
  CHAT_ANALYSIS_LIST_VIEWED: {
    amp: 'Chat Analysis List - Viewed',
    ga: 'chat_analysis_list_viewed',
  }, // [채팅 분석 리스트] 화면 진입
  CHAT_ANALYSIS_LIST_TYPE_CLICKED: {
    amp: 'Chat Analysis List - Type Clicked',
    ga: 'chat_analysis_list_type_clicked',
  }, // [채팅 분석 리스트] 타입 상단 버튼 클릭
  CHAT_ANALYSIS_LIST_NEW_CLICKED: {
    amp: 'Chat Analysis List - New Clicked',
    ga: 'chat_analysis_list_new_clicked',
  }, // [채팅 분석 리스트] 새 분석 클릭
  CHAT_ANALYSIS_LIST_ITEM_CLICKED: {
    amp: 'Chat Analysis List - Item Clicked',
    ga: 'chat_analysis_list_item_clicked',
  }, // [채팅 분석 리스트] 아이템 클릭
  CHAT_ANALYSIS_NOT_FOUND_ME_SCREEN_VIEWED: {
    amp: 'Chat Analysis Not Found Me - Screen Viewed',
    ga: 'chat_analysis_not_found_me_screen_viewed',
  }, // [채팅 분석 나를 찾을 수 없어요] 화면 진입
  CHAT_ANALYSIS_NOT_FOUND_ME_RESULT_BUTTON_CLICKED: {
    amp: 'Chat Analysis Not Found Me - Result Button Clicked',
    ga: 'chat_analysis_not_found_me_result_button_clicked',
  }, // [채팅 분석 나를 찾을 수 없어요] 결과 버튼 클릭
  CHAT_ANALYSIS_NOT_FOUND_ME_MAIN_BUTTON_CLICKED: {
    amp: 'Chat Analysis Not Found Me - Main Button Clicked',
    ga: 'chat_analysis_not_found_me_main_button_clicked',
  }, // [채팅 분석 나를 찾을 수 없어요] 메인 버튼 클릭
  CHAT_ANALYSIS_VIEW_AD_CLICKED: {
    amp: 'Chat Analysis View Ad - Clicked',
    ga: 'chat_analysis_view_ad_clicked',
  }, // [채팅 분석 로딩] 광고 보기 클릭
  CHAT_ANALYSIS_RECEIVE_ALARM_CLICKED: {
    amp: 'Chat Analysis Receive Alarm - Clicked',
    ga: 'chat_analysis_receive_alarm_clicked',
  }, // [채팅 분석 로딩] 알림 켜기 클릭
  CHAT_ANALYSIS_ATTACHMENT_TYPE_DETAIL_BUTTON_CLICKED: {
    amp: 'Chat Analysis Attachment Type Detail - Button Clicked',
    ga: 'chat_analysis_attachment_type_detail_button_clicked',
  }, // [채팅 분석 애착 유형] 자세히 버튼 클릭
  CHAT_ANALYSIS_ATTACHMENT_TYPE_DETAIL_VIEWED: {
    amp: 'Chat Analysis Attachment Type Detail - Viewed',
    ga: 'chat_analysis_attachment_type_detail_viewed',
  }, // [채팅 분석 애착 유형 상세] 화면 진입
  CHAT_ANALYSIS_ATTACHMENT_TYPE_DETAIL_SHARE_CLICKED: {
    amp: 'Chat Analysis Attachment Type Detail - Share Clicked',
    ga: 'chat_analysis_attachment_type_detail_share_clicked',
  }, // [채팅 분석 애착 유형 상세] 공유하기 클릭

  //[채팅 분석 예시] 화면 진입
  CHAT_ANALYSIS_EXAMPLE_PAGE_VIEWED: {
    amp: "Chat Analysis Example - Page Viewed",
    ga: "chat_analysis_example_page_viewed"
  },

  //[채팅 분석 생성] 예시 보기 버튼 클릭
  CHAT_ANALYSIS_CREATE_EXAMPLE_BUTTON_CLICKED: {
    amp: "Chat Analysis Create - Example Button Clicked",
    ga: "chat_analysis_create_example_button_clicked"
  },

  //[채팅 분석 예시] 탭 버튼 클릭
  CHAT_ANALYSIS_EXAMPLE_TAB_CLICKED: {
    amp: "Chat Analysis Example - Tab Clicked",
    ga: "chat_analysis_example_tab_clicked"
  }
}
